import { render, staticRenderFns } from "./qrFrame.vue?vue&type=template&id=dd263868&scoped=true"
import script from "./qrFrame.vue?vue&type=script&lang=js"
export * from "./qrFrame.vue?vue&type=script&lang=js"
import style0 from "./qrFrame.vue?vue&type=style&index=0&id=dd263868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd263868",
  null
  
)

export default component.exports